import { apiGet, apiPost, apiDelete } from '../../api/index';
import { urlInscripcionExamen } from '../../api/urls';


export function getFormData({
  idExamen,
  loadStudents,
  onSuccess,
  onError,
}) {
  return apiGet(`${urlInscripcionExamen}/form_data${idExamen ? `/${idExamen}/${loadStudents}` : ''}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function getInscripcionExamen(id, callback) {
  return apiGet(`${urlInscripcionExamen}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}


export function saveInscripcionExamen(inscripcion, callback) {
  return apiPost(`${urlInscripcionExamen}/inscribir`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveInscripcionesExamen(inscripcion, callback) {
  return apiPost(`${urlInscripcionExamen}`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveMiInscripcion(inscripcion, callback) {
  return apiPost(`${urlInscripcionExamen}/inscribirme`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function actualizarNotasProfesor(inscripcion, callback) {
  return apiPost(`${urlInscripcionExamen}/update-score`, inscripcion)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}


export function deleteInscripcionExamen(id, callback) {
  return apiDelete(`${urlInscripcionExamen}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchMyExams(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlInscripcionExamen}/my-exams`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
